
import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';
import styled from "styled-components";
import { Helmet } from 'react-helmet';

const Contact = (props) => {


const [messageSent, setMessageSent] =  useState(false);
const [messageError, setMessageError] = useState('');
const [isSending, setIsSending] = useState(false);
const [captchaToken, setCaptchaToken] = useState(null);
const form = useRef()
const captcha = useRef()
const formOpenedAt = useRef(Date.now());


const sendMessage = async (e) => {
  e.preventDefault();

  setMessageSent(false);
  setMessageError('');

  // Bots commonly fill every field, including fields hidden from real visitors.
  if (form.current.website.value) {
    e.target.reset();
    setMessageSent(true);
    return;
  }

  // Reject submissions completed too quickly to have been written by a person.
  if (Date.now() - formOpenedAt.current < 3000) {
    setMessageError('Please wait a moment, then try again.');
    return;
  }

  // Prevent rapid repeat submissions from the same browser.
  const lastSentAt = Number(localStorage.getItem('contactLastSentAt') || 0);
  if (Date.now() - lastSentAt < 30000) {
    setMessageError('Please wait 30 seconds before sending another message.');
    return;
  }

  if (!captchaToken) {
    setMessageError('Please confirm that you are not a robot.');
    return;
  }

  setIsSending(true);

  try {
    await emailjs.sendForm(
      'service_take53w',
      'template_iabqi5x',
      form.current,
      'tJk3SteWZD_wRsIkO'
    );

    localStorage.setItem('contactLastSentAt', Date.now().toString());
    e.target.reset();
    captcha.current.reset();
    setCaptchaToken(null);
    formOpenedAt.current = Date.now();
    setMessageSent(true);
  } catch (error) {
    console.error('Unable to send contact message:', error);
    captcha.current.reset();
    setCaptchaToken(null);
    setMessageError('Message could not be sent. Please try again.');
  } finally {
    setIsSending(false);
  }
};



const [scrollPos, setScrollPos] = useState(0);
useEffect(() => { 
  window.addEventListener('scroll', handleScroll);
  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
}, []);


const handleScroll = () => {
  setScrollPos(window.scrollY);
};

  return (
    <>
    <Helmet>
      
        <title>Contact</title>
        <meta name="description" content="Get in touch with RolandStudios - the premier destination for the latest and greatest Steam and PlayStation games. Contact for support, inquiries, and to share your feedback. Always ready to assist." />
        <link rel="canonical" href ="/contact" />
       
    </Helmet>

    <BackgroundTile scrollPos={scrollPos}>
    </BackgroundTile>  
    <Background scrollPos={scrollPos}>
        <img src="/images/About.jpg" />
      </Background>
  
      
     
    <Container>
    <Title>CONTACT</Title>
        <ContactInfo>
          <h1>Roland Womack</h1>
          <div className="emailLabel">LEGACY EMAIL</div>
          <a href="mailto:roland@rolandstudios.com">roland@rolandstudios.com</a>
          <div className="contactNote">
            <strong>BEST WAY TO REACH ME</strong>
            <p>Use the secure message form below.</p>
            <p>Name and email are optional, so you may remain anonymous. Include your email only if you would like a reply.</p>
          </div>

        </ContactInfo>
        <br></br>

        <Title>MESSAGE</Title>
    <ContactForm>
    
      
      <form ref={form} onSubmit={sendMessage}>
      <Fields>
      <div className="fieldGroup">
        <label htmlFor="contact-name">Your Name <span>(optional)</span></label>
        <input id="contact-name" type="text" name="name" maxLength="80" />
      </div>

      <div className="fieldGroup">
        <label htmlFor="contact-email">Your Email <span>(optional)</span></label>
        <input id="contact-email" type="email" name="email" maxLength="254" />
      </div>

      <div className="fieldGroup">
        <label htmlFor="contact-message">Message <span>(required)</span></label>
        <textarea id="contact-message" name="message" required minLength="10" maxLength="3000" />
      </div>

      <input
        type="text"
        name="website"
        tabIndex="-1"
        autoComplete="off"
        aria-hidden="true"
        style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px' }}
      />
    
      </Fields>
      <CaptchaArea>
        <ReCAPTCHA
          ref={captcha}
          sitekey="6LeQ4qEtAAAAAFMkTE4-FvmJF8KF0tW7In2go5Mb"
          theme="dark"
          onChange={setCaptchaToken}
          onExpired={() => setCaptchaToken(null)}
        />
      </CaptchaArea>
      <SubmitRow>
        <Submit>
          <input
            className="submitStyle"
            type="submit"
            value={isSending ? "SENDING..." : "SEND"}
            disabled={isSending || !captchaToken}
          />
        </Submit>
        {messageSent ? <MessageStatus>[ Message Sent ]</MessageStatus> : null}
      </SubmitRow>
      {messageError ? <div role="alert"><br></br>[ {messageError} ]</div> : null}
    </form>
    </ContactForm>
 
    </Container>
    </>
  );
}


const BackgroundTile = styled.div`
filter: ${({ scrollPos }) => `blur(${Math.min(scrollPos / 5, 30)}px) brightness(${ Math.max(100-scrollPos/5,40)}%)`};
  height:100vh;
  width:100vw;
  min-height:3200px;
  opacity:1;
  animation: move-diagonally 8s linear infinite;
  z-index:-1;

position:fixed;
 top:-1000px;

  background: url(/images/checkertile.png) repeat;
  @keyframes move-diagonally {
    from {
      background-position: 0 0;
    }
    to {
      background-position: -600px -600px;
    }
  }
`;

const Background = styled.div`

  position: fixed;
  opacity: 1;
  z-index: 1;
  top:0;
  height:100vh;
  width:100vw;

  filter: ${({ scrollPos }) => `blur(${Math.min(scrollPos / 5, 30)}px) brightness(${ Math.max(100-scrollPos/5,40)}%)`};
  img { 
    box-shadow: 4px 4px 2px 2px rgba(0,0,0,0.5);; 
    width:100vw;
    height:auto;
  }
`;
  

const ContactInfo = styled.div`
position:relative;
max-width:700px;
height:auto;
box-sizing:border-box;
background-color: rgba(55,55,55,0.75);  /* translucent white background */
border: 1px solid rgba(255,255,255,0.1);
border-radius:12px;
box-shadow: 12px 12px 50px 2px rgba(0,0,0,0.5);; 

padding: 42px 58px 48px;
h1{
  margin: 0 0 28px 0;
  padding:0;
  font-weight:700;
  font-size:25px;
}
.emailLabel{
  color:yellow;
  font-size:12px;
  font-weight:800;
  letter-spacing:1.8px;
  margin-bottom:5px;
}
a{
  color:white;
  display:inline-block;
  font-size:17px;
  text-decoration:none;
  border-bottom:1px solid rgba(255,255,255,0.35);
  padding-bottom:2px;
}
a:hover{
  color:yellow;
  border-color:yellow;
}
.contactNote{
  border-left:3px solid yellow;
  margin-top:30px;
  padding:3px 0 3px 18px;
  max-width:520px;
}
.contactNote strong{
  display:block;
  color:yellow;
  font-size:12px;
  letter-spacing:1.5px;
  margin-bottom:8px;
}
p{
  margin:0 0 7px 0;
  padding:0;
  font-weight:200;
  font-size:14px;
  line-height:1.45;
}
.contactNote p:last-child{
  color:rgba(255,255,255,0.72);
  margin-bottom:0;
}

@media (max-width:800px){
  width:330px;
  left:16px;
  padding:16px;
  margin:0;
}

`;
const Container = styled.div`

position: relative;
opacity: 1;
z-index: 1;
min-height:500px;
max-width:800px;

left:70px;
top:200px;
height:100vh;;

@media (max-width:800px){
  left:16px;
  width:330px;
  padding:0;
  margin:0;
  top:100px;
}
`;


const ContactForm = styled.div`
  background-color: rgba(55,55,55,0.75); 
  border: 1px solid rgba(255,255,255,0.1);
  border-radius:12px;
  box-shadow: 12px 12px 50px 2px rgba(0,0,0,0.5);; 
  width:700px;
  box-sizing:border-box;

padding: 46px 50px 50px;
h1{
  color: #003200;
  font-weight:900;
  font-size:20px;
  margin:0;
  text-shadow: 2px 2px 4px #333;
}

@media (max-width:800px){
  left:16px;
  width:330px;
  padding:10px;
  margin:0;
  top:100px;

}
`;



const Fields = styled.div`
.fieldGroup{
  display:flex;
  flex-direction:column;
  gap:7px;
  margin-bottom:18px;
}
label{
  font-weight:700;
  line-height:1.2;
}
label span{
  color:rgba(255,255,255,0.58);
  font-size:12px;
  font-weight:400;
}
input,textarea{
  box-sizing:border-box;
  width:100%;
  padding:10px 10px 10px 10px;

  border-color:white;
  text-shadow: 2px 2px 4px #333;
  background-color: rgba(255,255,255,0.05); 
  border: 1px solid rgba(255,255,255,0.1);
  border-radius:4px;
  
}
textarea{
  width:100%;
  max-width:100%;
  min-width:100%;
  height: 160px;
  font-size:16px;
}

@media (max-width:800px){
  left:16px;
  width:330px;
  padding:0;
  margin:0;
  top:100px;

  input,textarea{
    left:0;
    padding:0;
    margin:0;
    width:300px;
max-width:300px;
min-width:300px;
    font-size:16px;
  }
}
`;

const CaptchaArea = styled.div`
  margin:24px 0 20px;
  width:304px;
  max-width:100%;
  overflow:hidden;
`;


const Title = styled.div`
font-size: 32px;
font-weight: 900;
line-height: 1;
color:yellow;
text-align: left;
padding: 20px 0px 20px 0px;
text-shadow: 2px 2px 4px #333;
`;

const SubmitRow = styled.div`
  display:flex;
  align-items:center;
  gap:18px;
  min-height:44px;
`;

const MessageStatus = styled.div`
  color:yellow;
  font-size:14px;
  font-weight:700;
  letter-spacing:0.5px;
  text-shadow:2px 2px 4px #333;
`;

const Submit = styled.div`
input,textarea{
 
  background-color: rgba(255,255,255,0.02);  /* translucent white background */
  border: 1px solid rgba(255,255,255,0.1);

  
  font-size:20px;
  font-weight:800;
  padding:2px 15px 2px 15px;
  border-radius:4px;
  cursor:pointer;


  padding: 8px 16px;
  text-transform: uppercase;
  letter-spacing: 1.5px;

  transition: all 0.2s ease 0s;

  &:disabled {
    cursor:not-allowed;
    opacity:0.45;
  }

  &:hover {

    color:rgb(0,0,0,.5);
    background-color: rgb(255,255,255,.75);
  }
}

`;

export default Contact;
